import React from 'react';

// Footer component
const Footer = () => {
  return (
    <footer className="bg-gray-200 text-gray-600 py-6 mt-12 w-full">
      {/* Container for footer content */}
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Top section of the footer */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-4">
          {/* Social media links */}
          <div className="flex justify-start space-x-4 mt-6 ml-0 md:ml-4">
            {/* Instagram link */}
            <a
              href="https://www.instagram.com/ml_learning1/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-full p-3 shadow-lg transition-transform transform hover:scale-105"
            >
              <i className="fab fa-instagram text-pink-600 text-2xl"></i>
            </a>
            {/* TikTok link */}
            <a
              href="https://www.tiktok.com/@ml_learning1?lang=en"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-full p-3 shadow-lg transition-transform transform hover:scale-105"
            >
              <i className="fab fa-tiktok text-black text-2xl"></i>
            </a>
            {/* Email link */}
            <a
              href="mailto:ml.learning01@gmail.com"
              className="bg-white rounded-full p-3 shadow-lg transition-transform transform hover:scale-105"
            >
              <i className="fas fa-envelope text-green-500 text-2xl"></i>
            </a>
          </div>
        </div>

        {/* Divider line */}
        <hr className="my-6 border-gray-300" />

        {/* Footer bottom text */}
        <div className="text-sm text-center w-full">
          {/* Display current year dynamically */}
          Copyright © {new Date().getFullYear()} MLMaths.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
